var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPocketcasts = function SvgPocketcasts(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#3b4c6a",
    rx: 6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M3.555 16c0-6.874 5.571-12.445 12.444-12.445s12.445 5.571 12.445 12.444h-3.111a9.333 9.333 0 1 0-9.334 9.333v3.112c-6.873 0-12.444-5.572-12.444-12.445Zm12.444 7.466a7.467 7.467 0 1 1 7.467-7.467H20.75a4.752 4.752 0 1 0-4.752 4.752z",
    clipRule: "evenodd"
  })));
};
export default SvgPocketcasts;